module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-06.0fd784e7.jpg";